import {Box, Modal} from "@mui/material";
import React, {useState} from "react";
import Draggable from "react-draggable";
import {ConfirmationDialog} from "../../../../components/common/confirmation-dialog/ConfirmationDialog";

interface IGenericModalProps {
	open: boolean;
	confirmClose?: boolean;
	confirmTitle?: string;
	confirmDescription?: string;
	confirmSuccessTitle?: string;
	confirmCancelTitle?: string;
	
	onClose: (value: boolean) => void;
	title: string;
	children: React.ReactNode;
}

export const GenericModal: React.FC<IGenericModalProps> = (props) => {
	const [showConfirm, setShowConfirm] = useState<boolean>(false);
	const style = {
		position: "absolute",
		
		transform: "translate(-50%, -50%)",
		width: "80%",
		bgcolor: "background.paper",
		borderRadius: "10px",
		boxShadow: 24,
		p: 4,
	};
	return (
		
		<div>
			
			<Modal open={props.open} onClose={() => {
				if (props.confirmClose) {
					setShowConfirm(true);
				} else {
					props.onClose(true);
				}
			}
			}
			disableEnforceFocus={true}>
				<span>
					<Draggable positionOffset={{x: "10%", y: "10%"}} handle={".handle"} >
						<Box sx={style}>
							<div style={{ maxHeight: "90vh", overflow: "auto" }}>
								<div className="handle" style={{cursor: "move"}}><h2>{props.title}</h2></div>
								{props.children}
							</div>

						</Box>
					</Draggable>
					{showConfirm &&
						<ConfirmationDialog open={true} buttonTitle={props.confirmTitle??"Close"} cancelTitle={props.confirmCancelTitle} successTitle={props.confirmSuccessTitle} dialogTitle={props.confirmTitle??"Close"} dialogDescription={props.confirmDescription} onSuccess={() => {
							setShowConfirm(false);
							props.onClose && props.onClose(true);
						}} onCancel={() => setShowConfirm(false)}/>
					}
				</span>
			</Modal>
		</div>
	);
};
